import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Button from 'components/UI/Button'

import { setStep } from 'routing/fetchingfunction/user/user.action'

import testsPassed from 'assets/image/calendar.png'

const TestResultBuffer = ({ onContinue }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // TODO compare lastPassedCategory index and selectedCategories.length - 1 to know what is the next step
  const { activeCategoryIndex, selectedCategories, passedTests } = useSelector(
    (state) => state.user
  )

  console.log(selectedCategories, activeCategoryIndex)

  const areAllTestsFailed =
    passedTests.every((test) => test.test.is_passed === false) &&
    passedTests.length === selectedCategories.length
  //  &&   passedTests.length !== 1

  return (
    <div className="flex flex-col items-center justify-start !text-white-50">
      <h3 className={` text-4xl text-center font-bold`}>All Tests have been completed!</h3>

      <div className="my-[50px]">
        <img className="block" src={testsPassed} alt="All tests are failed" />
      </div>

      <Button
        variant="primary"
        onClick={() => onContinue(1)}
        className="shadow-button-second shadow border !border-gray-600/30 max-w-lg w-full"
      >
        {areAllTestsFailed ? 'Finish Registration' : 'Go to Result'}
      </Button>
    </div>
  )
}

export default TestResultBuffer
